export default __webpack_public_path__ + "static/feature_1-6e86658f3b38964806a1ea562eca1c7b.png";